<template>
  <!-- onboarding-step-1 -->
    <div class="d-flex flex-column align-items-center w-100 onboarding-container px-20">
      <div v-if="!hasTileSelected">
        <div class="d-flex flex-column align-items-center">
            <h5 class="introduce fw-bold fs-15">
                Choose Personalisation Settings
            </h5>
            <div class="introduce description-text">
                Options selected here will filter the search and choices can be updated on search page
            </div>
        </div>
        <el-row class="memberType-tile-container"  :gutter="0">
          <el-col v-bind="getResponsiveCol(index, 'memberType')" v-for="(tile, index) in memberTypes" :key="tile.type">
              <onboarding-selection-tile
                :title="tile.name"
                :icon="tile.icon"
                v-model="tile.selected"
              />
          </el-col>
        </el-row>
      </div>
      <div v-else >
        <!-- <div class="introduce text-center">{{getContentScript}}</div> -->
        <el-page-header @back="goBackStep1" class=" step-2 px-20" :title="getContentScript" >
          <template slot="content" class="step-2-content">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <h5 class="introduce fw-bold fs-13  ">
                I would like to:
              </h5>
            </div>
          </template>
        </el-page-header>
        <el-row class="memberType-tile-container" :gutter="0">
          <el-col v-bind="getResponsiveCol(index, 'regoType')" v-for="(regoTile,index) in regoTypeTilesArray" :key="regoTile.title">
              <onboarding-selection-tile
                :title="regoTile.title"
                :description="regoTile.description"
                :icon="regoTile.icon"
                v-model="regoTile.selected"
              />
          </el-col>
        </el-row>
        </div>
    </div>
</template>

<script>
import { memberTypeTiles, regoTypeTiles } from '@/utils/constants';
import OnboardingSelectionTile from './components/onboarding-selection-tile.vue';

export default {

  name: 'OnboardingStep1',
  components: {
    OnboardingSelectionTile
  },
  data() {
    return {
      memberTypes: [],
      memberTypeTiles,
      selectedMemberType: undefined,
      //   {
      //     title: 'Coach',
      //     value: 'coach',
      //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      //     imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
      //     selected: false
      //   },
      //   {
      //     title: 'Manager',
      //     value: 'manager',
      //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      //     imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
      //     selected: false
      //   },
      //   {
      //     title: 'Official',
      //     value: 'official',
      //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      //     imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
      //     selected: false
      //   },
      //   {
      //     title: 'Player',
      //     value: 'player',
      //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      //     imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
      //     selected: false
      //   },
      //   {
      //     title: 'Volunteer',
      //     value: 'volunteer',
      //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      //     imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
      //     selected: false
      //   }
      // ],
      regoTypeTilesArray: regoTypeTiles
    };
  },
  async created() {
    // memberTypeTiles.forEach((tile) => {
    //   // eslint-disable-next-line no-param-reassign
    //   tile.selected = false;
    // });
    regoTypeTiles.forEach((tile) => {
      // eslint-disable-next-line no-param-reassign
      tile.selected = false;
    });
    const response = await this.$http.get('/assemble/api/v1/portal/nationals/member-types');
    this.memberTypes = response.data.data;
    console.log(this.memberTypes);
    if (this.memberTypes.length > 0) {
      this.memberTypes = this.memberTypes.map((memberType) => {
        // eslint-disable-next-line no-param-reassign
        // memberType.selected = false;
        if (memberType.referee === true) {
          // eslint-disable-next-line no-param-reassign
          memberType.icon = 'whistle';
        } else if (memberType.type === 'coach') {
          // eslint-disable-next-line no-param-reassign
          memberType.icon = 'fa-chalkboard-user';
        } else if (memberType.type === 'manager') {
          // eslint-disable-next-line no-param-reassign
          memberType.icon = 'fa-user-tie';
        } else if (memberType.type === 'official') {
          // eslint-disable-next-line no-param-reassign
          memberType.icon = 'fa-user-tie';
        } else if (memberType.type === 'volunteer') {
          // eslint-disable-next-line no-param-reassign
          memberType.icon = 'fa-user-friends';
        }
        return {
          ...memberType,
          selected: false
        };
      });
      this.memberTypes = this.memberTypes.filter((memberType) => memberType.type !== 'legacy-membership');
      console.log('this.memberTypes', this.memberTypes);
    }
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    responsiveCol() {
      return {
        xs: 12, sm: 12, md: 8, lg: 8
      };
    },
    hasTileSelected() {
      console.log(this.memberTypes.some((tile) => tile.selected));
      const memberType = this.memberTypes.find((tile) => tile.selected);
      return memberType !== undefined;
    },
    getContentScript() {
      return `I am a ${this.memberTypes.find((tile) => tile.selected).name} and ...`;
    },
  },
  methods: {
    getResponsiveCol(index, type) {
      const baseCols = {
        xs: 12,
        sm: 12,
        md: 8,
        lg: 8
      };
      const itemsInLastRow = type === 'memberType' ? this.memberTypes.length % 3 : this.regoTypeTilesArray.length % 3;
      const isInLastRow = type === 'memberType' ? index >= this.memberTypes.length - itemsInLastRow : index >= this.regoTypeTilesArray.length - itemsInLastRow;

      if (isInLastRow) {
        let offset = 0;

        if (type === 'memberType') {
          if (itemsInLastRow === 1 && index === this.memberTypes.length - 1) {
            offset = 8;
          } else if (itemsInLastRow === 2 && index === this.memberTypes.length - 2) {
            offset = 4;
          }
        } else if (type === 'regoType') {
          if (itemsInLastRow === 1 && index === this.regoTypeTilesArray.length - 1) {
            offset = 8;
          } else if (itemsInLastRow === 2 && index === this.regoTypeTilesArray.length - 2) {
            offset = 4;
          }
        }

        return {
          ...baseCols,
          md: { span: 8, offset },
          lg: { span: 8, offset }
        };
      }

      return baseCols;
    },
    goBackStep1() {
      console.log('goBackStep1', this.memberTypes);
      this.memberTypes = this.memberTypes.map((memberType) => ({
        ...memberType,
        selected: false
      }));
    },
    changeRegoType() {
    }
  },
  watch: {
    regoTypeTilesArray: {
      handler() {
        const selectedRegoType = this.regoTypeTilesArray.find((tile) => tile.selected);

        const memberType = this.memberTypes.find((memberTile) => memberTile.selected);
        let memberTypesFilter = [];
        console.log('memberType', memberType);
        if (memberType) {
          memberTypesFilter = memberType.type;
        }
        if (selectedRegoType) {
          console.log('find', selectedRegoType.value, memberTypesFilter);
          const type = selectedRegoType.value;
          console.log('type', type);
          const memberTypes = selectedRegoType.value === 'team' ? '' : memberTypesFilter;
          this.$store.commit('finder/setFilters', { type, memberType: memberTypes });
          const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
          this.$router.push({ name: pathName, params: { type, memberType: memberTypes } });
        }
      },
      deep: true
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep .el-page-header__left{
  align-items: center;
}
.onboarding-container {
    width: 100%;
    max-width: $md !important;
    .step-2{
      display: grid;
      // grid-template-columns: 1fr 9fr;
      .step-2-content{
        width: 100%;
        max-width: $md !important;
      }

    }
  .introduce {
    // font-size: 1rem;
    // font-weight: 500;
    margin-bottom: 1rem;
    padding: 0 1rem;
    text-align:center !important;
    &.step-2-introduce {
      margin-left: -8rem;
    }
    &.description-text {
      font-size: 0.9rem;
      color: #666;
      font-weight: normal;
      margin-top: 0.5rem;
      line-height: 1.4;
    }
  }
  .main-tile-container{
    width: 100%;
    // max-width: $md !important;
  }
}
</style>
